<template>
  <div>
    <v-breadcrumbs
      :items="breadcrumbs"
      class="grey lighten-2 white--text"
    ></v-breadcrumbs>
    <v-progress-circular
      v-if="loading"
      :size="100"
      :width="4"
      color="fmq_black"
      indeterminate
      class="d-flex mx-auto py-8 mt-8"
    ></v-progress-circular>
    <div v-else>
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-4">
          <v-btn
            small
            depressed
            color="fmq_gray"
            dark
            outlined
            to="/notificacoes"
          >
            <v-icon small> mdi-arrow-left </v-icon>Voltar</v-btn
          >
        </div>
        <NotificacaoFormulario
          :item="item"
          @send="editar"
          :listFuncionarios="listFuncionarios"
          :listForcaDeVendas="listForcaDeVendas"
          :loadingBtn="loadingBtn"
        />
      </div>
    </div>
    <AlertSuccess
      :dialog="success"
      dialogMessage="Notificação editada com sucesso"
      @close="goTo"
    />
    <AlertError :alertError="error" :messageError="messageError" />
  </div>
</template>

<script>
import { showNotification, editNotification } from "@/services/notification.js";
import NotificacaoFormulario from "@/components/notificacoes/NotificacaoFormulario.vue";
import { listEmployee } from "@/services/employee";
import { listSaleForce } from "@/services/sale-force";
export default {
  name: "NotificacaoEditar",
  components: { NotificacaoFormulario },
  data: () => ({
    breadcrumbs: [
      {
        text: "Notificações",
        disabled: false,
        to: "/notificacoes",
      },
      {
        text: "Editar Notificação",
        disabled: true,
        to: "",
      },
    ],
    error: false,
    item: {},
    messageError: null,
    loading: false,
    listFuncionarios: [],
    listForcaDeVendas: [],
    loadingBtn: false,
  }),
  created() {
    this.listarFuncionarios();
    this.listarForcaDeVendas();
    this.exibir();
  },
  methods: {
    async exibir() {
      this.error = false;
      this.loading = true;
      try {
        const resp = await showNotification(this.$route.params.id);
        this.item = resp.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    async editar(event) {
      this.error = false;
      this.sucess = false;
      this.loadingBtn = true;
      try {
        await editNotification(this.$route.params.id, event).then(() => {
          this.success = true;
        });
        this.loadingBtn = false;
      } catch (e) {
        this.loadingBtn = false;
        this.error = true;
        this.messageError = e.response.data.message;
      }
    },
    async listarFuncionarios() {
      const resp = await listEmployee();
      this.listFuncionarios = resp.data;
    },
    async listarForcaDeVendas() {
      const resp = await listSaleForce();
      this.listForcaDeVendas = resp.data;
    },
    goTo() {
      this.sucess = false;
      this.$router.push({ name: "Notificacoes" });
    },
  },
};
</script>

<style></style>
